import { FC } from 'react';
import { FATCATranslations } from '../../../utils/getFATCATranslations';
import { ButtonBase } from '../../../../common';
import { useFATCAFormState } from '../../../utils/useFATCAFormState';

const FATCANoAccessRealStocksScreen: FC<{
  translations: FATCATranslations;
  fatcaFormState: ReturnType<typeof useFATCAFormState>;
}> = ({ translations, fatcaFormState }) => {
  return (
    <ButtonBase fullWidth size="large" onClick={fatcaFormState.onNextStep}>
      {translations.i_understand}
    </ButtonBase>
  );
};

export { FATCANoAccessRealStocksScreen };
